module.exports = __webpack_public_path__ + "img/9788957981023.65ff4086.jpg";